<style scoped lang="scss">
    @import url('https://fonts.googleapis.com/css2?family=Herr+Von+Muellerhoff&display=swap');
    @import url('https://fonts.googleapis.com/css2?family=Yellowtail&display=swap');
    .signature-grid {
        margin-top: 10px;
        height: 60px;
        /*width: 100%;*/
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .signature-line {
        flex-grow: 1;
        margin: 5px;
        padding-bottom: 5px;
        border-bottom: thin solid black;

        .content {
            padding-top: 10px;
        }
        &.signature-container {

            .content {
                padding-top: 5px;
                font-size: 22pt;
                font-family: 'Yellowtail', cursive;
            }
        }

        .label {
            color: #666;
            font-size: 0.8em;
        }
    }
</style>

<template>
    <div class="signature-grid">
        <div class="signature-line signature-container" style="width: 40%">
            <div class="label">Signature <span class="custom-label" v-if="label">({{ label }})</span></div>
            <div class="content">{{ name }}</div>

        </div>
        <div class="signature-line name-container" style="width: 40%">
            <div class="label">Name</div>
            <div class="content">{{ name }}</div>
        </div>
        <div class="signature-line date-container" style="width: 20%">
            <div class="label">Date</div>
            <div class="content">
                <span v-if="name">{{ dateString }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    // import moment from 'moment';

    export default {
        name: "Signatures",
        props: {
            number: {
                type: Number,
                default: 1,
            },
            name: {
                type: String,
                default: null,
            },
            label: {
                type: String,
                default: null,
            }
        },
        computed: {
            dateString() {
                return moment().format('MM/DD/YYYY')
            }
        }
    }
</script>
